import { render } from "./Tutorial.vue?vue&type=template&id=84ab9096&scoped=true"
import script from "./Tutorial.vue?vue&type=script&lang=js"
export * from "./Tutorial.vue?vue&type=script&lang=js"

import "./Tutorial.vue?vue&type=style&index=0&id=84ab9096&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84ab9096"]])

export default __exports__